const snout = ['Essex', 'Clinton', 'Franklin', 'St Lawrence', 'Jefferson', 'Lewis', 'Oswego', 'Cayuga', 'Wayne'];

export default snout;